import { all } from "redux-saga/effects";
import { userSaga } from "./user";
import { pointSaga } from "./point";
import { brandSaga } from "./brand";
import { modifierSaga } from "./modifiers";
import { ordersSaga } from "./orders";

export function* rootSaga() {
  yield all([
    userSaga(),
    pointSaga(),
    brandSaga(),
    modifierSaga(),
    ordersSaga(),
  ]);
}
